export const getEnvVarAsBoolean = (value) => {
	if (!value) {
		return false
	}
	if (value === 'false' || value === 'disabled') {
		return false
	}
	return true
}

export const getEnvVarAsInteger = (valueStr: string) => {
	const value = parseInt(valueStr)
	if (isNaN(value)) {
		return 0
	}
	return value
}
